

<template>
  <!-- Contact Form Start -->
  <section class="contact_form_area pt-0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="site_heading">
            <h3 class="sub_title">Get in touch</h3>
            <h2 class="section_title">Send Us Message</h2>
            <img src="../assets/img/section_delimiter.png" alt="img" class="section_devider">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="mapCanvas">
            <iframe class="map-pizzon"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2293.1228588802205!2d-2.940742383978084!3d54.918316163505814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487d1a03882d54af%3A0xa4639d28db5b99d9!2s55%20Drumburgh%20Ave%2C%20Carlisle%20CA3%200PD%2C%20UK!5e0!3m2!1sen!2sin!4v1599636489278!5m2!1sen!2sin"
                    style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="contact_form_inn">
            <form>
              <div class="row">
                <div class="col-lg-6">
                  <div class="comment_field">
                    <label hidden for="name">name</label>
                    <input id="name" class="ns-com-name" name="name" placeholder="Name" type="text">
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="comment_field">
                    <label hidden for="email">email</label>
                    <input id="email" class="ns-com-name" name="email" placeholder="Email" type="email">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="comment_field">
                    <label hidden for="sub">subject</label>
                    <input id="sub" class="ns-com-name" name="sub" placeholder="Subject" type="text">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="comment_field">
                    <label hidden for="textarea">textarea</label>
                    <textarea id="textarea" class="comment" placeholder="Write your message here..."
                              name="comment"></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="comment_field form_action">
                    <button type="submit">Send Message</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Form End -->
</template>
<script>
export default {
  name: 'ContactForm'
}
</script>



// WEBPACK FOOTER //
// src/components/ContactForm.vue